"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  deliveryInfo: {
    title: 'Deliverable Date & Freight',
    baseInfo: 'BLNO INFO',
    blNo: 'B/L No.',
    containerNo: 'Container No.',
    vessel: 'VESSEL：',
    eta: 'ETA：',
    deliverableDate: 'Deliverable Date：',
    feeInfo: 'FREIGHT DETAIL',
    rate: 'RATE',
    containerQuantity: 'CONTAINER QUANTITY',
    total: 'AMOUNT（WITHOUT OF）：',
    chargeCode: 'CHARGE CODE',
    containerType: 'CONTAINER TYPE',
    amount: '$RECEVICE FEE',
    tips_1: 'Warm Tips：',
    tips_2: '(1) The time and cost information of the exchangeable order for import is for reference only, and the actual written notice such as mail and fax shall prevail.'
  }
};